var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c(
        "gg-card-header",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    md: "6"
                  }
                },
                [_vm._v(" Feature Lists ")]
              ),
              _c(
                "v-col",
                {
                  staticClass: "text-right font-sm",
                  attrs: {
                    md: "6"
                  }
                },
                [
                  _c(
                    "gg-btn",
                    {
                      attrs: {
                        disabled: !_vm.featureListingAllowed,
                        color: "primary"
                      },
                      on: {
                        click: function click($event) {
                          return _vm.openCreateModal()
                        }
                      }
                    },
                    [_vm._v(" Add Feature List ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      !_vm.featureListingAllowed
        ? _c(
            "gg-card-text",
            [
              _c(
                "v-row",
                [
                  _c("v-col", [
                    _vm._v(
                      " You don't have enough permissions for this action "
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        : _c(
            "gg-card-text",
            [
              _c("v-data-table", {
                attrs: {
                  items: _vm.featureList,
                  loading: _vm.loading,
                  headers: _vm.headers
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.manage",
                    fn: function fn(_ref) {
                      var item = _ref.item
                      return [
                        _c(
                          "v-menu",
                          {
                            attrs: {
                              "offset-y": ""
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function fn(_ref2) {
                                    var on = _ref2.on,
                                      attrs = _ref2.attrs
                                    return [
                                      _c(
                                        "gg-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                color: "primary"
                                              }
                                            },
                                            "gg-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _vm._v(" Manage "),
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                right: ""
                                              }
                                            },
                                            [_vm._v("mdi-chevron-down")]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _c(
                              "v-list",
                              [
                                _c(
                                  "v-list-item",
                                  {
                                    on: {
                                      click: function click($event) {
                                        return _vm.openEditModal(item.name)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-list-item-title",
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "pb-1",
                                            attrs: {
                                              small: ""
                                            }
                                          },
                                          [_vm._v("mdi-pencil")]
                                        ),
                                        _c("span", [_vm._v(" Edit ")])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item",
                                  {
                                    on: {
                                      click: function click($event) {
                                        return _vm.deleteFeatureList(item.name)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-list-item-title",
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "pb-1",
                                            attrs: {
                                              small: ""
                                            }
                                          },
                                          [_vm._v("mdi-trash-can-outline")]
                                        ),
                                        _vm._v(" Delete ")
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
      _c("gg-modal", {
        attrs: {
          "is-active": _vm.isCreateModal
        },
        on: {
          close: function close($event) {
            _vm.isCreateModal = false
          }
        },
        scopedSlots: _vm._u([
          {
            key: "toolbar",
            fn: function fn() {
              return [_vm._v(" Create Feature List ")]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function fn() {
              return [
                _c("gg-text-field", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  attrs: {
                    outlined: "",
                    placeholder: "Enter new Feature List name",
                    "data-vv-name": "featurelist",
                    "data-vv-as": "Feature List name",
                    "error-messages": _vm.errors.collect("featurelist")
                  },
                  on: {
                    keyup: function keyup($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.createFeatureList($event)
                    }
                  },
                  model: {
                    value: _vm.newFeatureList.featurelist,
                    callback: function callback($$v) {
                      _vm.$set(_vm.newFeatureList, "featurelist", $$v)
                    },
                    expression: "newFeatureList.featurelist"
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "actions",
            fn: function fn() {
              return [
                _c(
                  "gg-btn",
                  {
                    attrs: {
                      primary: "",
                      loading: _vm.isCreatingFeatureList
                    },
                    on: {
                      click: _vm.createFeatureList
                    }
                  },
                  [_vm._v(" Create ")]
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("gg-modal", {
        attrs: {
          "is-active": _vm.isEditModal
        },
        on: {
          close: function close($event) {
            _vm.isEditModal = false
          }
        },
        scopedSlots: _vm._u([
          {
            key: "toolbar",
            fn: function fn() {
              return [_vm._v(" Add Features to List ")]
            },
            proxy: true
          },
          {
            key: "title",
            fn: function fn() {
              return [
                _c("v-checkbox", {
                  staticStyle: {
                    margin: "0",
                    padding: "0"
                  },
                  attrs: {
                    label: "Select all features for package ".concat(
                      _vm.editedFeatureList
                    )
                  },
                  on: {
                    change: _vm.selectAll
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function fn() {
              return [
                _c("gg-text-field", {
                  attrs: {
                    outlined: "",
                    placeholder: "Type for searching"
                  },
                  on: {
                    input: _vm.filterFormData
                  },
                  model: {
                    value: _vm.filter,
                    callback: function callback($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter"
                  }
                }),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "grid",
                      "grid-template-columns": "1fr 1fr"
                    }
                  },
                  _vm._l(_vm.formData, function(feature, index) {
                    return _c("v-checkbox", {
                      key: index,
                      staticStyle: {
                        margin: "0",
                        padding: "0"
                      },
                      attrs: {
                        id: feature.name,
                        label: feature.label,
                        disabled: _vm.isLoadingFeaturesForList
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "label",
                            fn: function fn() {
                              return [
                                _c(
                                  "label",
                                  {
                                    attrs: {
                                      for: feature.name
                                    }
                                  },
                                  [_vm._v(_vm._s(feature.label))]
                                ),
                                feature.isPlugin
                                  ? _c(
                                      "v-chip",
                                      {
                                        staticClass: "ma-2",
                                        attrs: {
                                          label: "",
                                          color: "primary",
                                          "text-color": "white",
                                          small: ""
                                        }
                                      },
                                      [_vm._v(" Plugin ")]
                                    )
                                  : _vm._e()
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: _vm.formData[index].value,
                        callback: function callback($$v) {
                          _vm.$set(_vm.formData[index], "value", $$v)
                        },
                        expression: "formData[index].value"
                      }
                    })
                  }),
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "actions",
            fn: function fn() {
              return [
                _c(
                  "gg-btn",
                  {
                    attrs: {
                      primary: "",
                      loading: _vm.isUpdatingFeatureList
                    },
                    on: {
                      click: _vm.applyFeatures
                    }
                  },
                  [_vm._v(" Save Changes ")]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }